// extracted by mini-css-extract-plugin
export default {"label":"WidgetModal_label__DJXcJ","copyBtnTooltip":"WidgetModal_copyBtnTooltip__hO5UW","copyBtnArrow":"WidgetModal_copyBtnArrow__aLujk"};